module.exports = __webpack_public_path__ + "img/d76461d.svg";